import { fetch } from '@biscuits/graphql';
import { createContext } from 'react';
import * as CONFIG from './config.js';
const SHORT_PULL = 45 * 1000;
export function getVerdantSync({ appId, initialPresence, access, }) {
    return {
        initialPresence,
        defaultProfile: {
            id: '',
            name: 'Anonymous',
            imageUrl: null,
        },
        useBroadcastChannel: true,
        fetchAuth: async () => {
            const response = await fetch(`${CONFIG.API_ORIGIN}/verdant/token/${appId}?access=${access}`, {
                credentials: 'include',
            });
            if (!response.ok) {
                throw new Error(`Failed to fetch Verdant auth token: ${response.status} ${response.statusText}`);
            }
            const data = await response.json();
            return data;
        },
        pullInterval: SHORT_PULL,
        automaticTransportSelection: 'peers-only',
    };
}
export const VerdantContext = createContext(null);
//# sourceMappingURL=verdant.js.map